export default __webpack_public_path__ + "static/media/MS-Login-right-img.e34a21d9.png";